import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex gap-4" }
const _hoisted_2 = { class: "flex gap-4" }
const _hoisted_3 = { class: "font-weight-bold" }

import {Button} from "@/components/ui/button";
  import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogFooter, DialogHeader, DialogTitle
  } from "@/components/ui/dialog";
  import {Input} from "@/components/ui/input";
  import TablesService from "@/services/tables/tables.service";
  import useEventsBus from "@/utils/eventBus";
  import {Separator} from "@/components/ui/separator";
  import {toTypedSchema} from "@vee-validate/zod";
  import * as z from "zod";
  import {useForm} from "vee-validate";
  import {watch} from "vue";
  import {
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
  } from '@/components/ui/form'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MatrixEditForm',
  props: {
    object: {},
    entity: {},
    open: { type: Boolean },
    setOpen: {}
  },
  setup(__props: any) {

  const props = __props
  const { emit } = useEventsBus();
  let matrix: any = {};
  const formSchema = toTypedSchema(z.object({
    r: z.number(),
    g: z.number(),
    group: z.number(),
    letter: z.string(),
    value1: z.string(),
    value2: z.string(),
    value3: z.string(),
    value4: z.string(),
  }))
  const { handleSubmit, values, setValues } = useForm({
    validationSchema: formSchema,
  })

  watch(values, (newFormData) => {
    matrix = newFormData;
  });

  const onSubmit = handleSubmit(async () => {
    let res;
    if (!props.object.id) {
      res = await TablesService.createRecord(matrix, props.entity);
    } else {
      res = await TablesService.updateRecord(matrix, props.entity);
    }
    if (res != undefined) {
      emit('update_'+props.entity, res.data);
    }
  })

  function parseMatrixValues(matrix: any) {
    const occurrence = JSON.parse(matrix.occurrence);
    matrix.value1 = occurrence.value1;
    matrix.value2 = occurrence.value2;
    matrix.value3 = occurrence.value3;
    matrix.value4 = occurrence.value4;
  }

  watch(() => props.open, async(_, newValue) => {
    if (newValue === false) {
      if (props.object.id) {
        const matrix = props.object;
        if (matrix.occurrence != '') {
          parseMatrixValues(matrix);
        }
        setValues(matrix);
      }
    }
  },{ immediate: true })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: props.open,
    "onUpdate:open": props.setOpen
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogContent), { class: "max-w-[60vw]" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogHeader), null, {
            default: _withCtx(() => [
              (!props.object.id)
                ? (_openBlock(), _createBlock(_unref(DialogTitle), { key: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('table.add')), 1)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_unref(DialogTitle), { key: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('table.edit')), 1)
                    ]),
                    _: 1
                  })),
              _createElementVNode("form", {
                onSubmit: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
                class: "mt-3"
              }, [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_unref(FormField), { name: "r" }, {
                    default: _withCtx(({ componentField }) => [
                      _createVNode(_unref(FormItem), { class: "w-full" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormLabel), null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('column.r')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(FormControl), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Input), _mergeProps({
                                type: "number",
                                placeholder: _ctx.$t('column.r')
                              }, componentField, { "auto-correct": "off" }), null, 16, ["placeholder"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_unref(FormMessage))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormField), { name: "g" }, {
                    default: _withCtx(({ componentField }) => [
                      _createVNode(_unref(FormItem), { class: "w-full" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormLabel), null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('column.g')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(FormControl), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Input), _mergeProps({
                                type: "number",
                                placeholder: _ctx.$t('column.g')
                              }, componentField, { "auto-correct": "off" }), null, 16, ["placeholder"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_unref(FormMessage))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_unref(FormField), { name: "group" }, {
                    default: _withCtx(({ componentField }) => [
                      _createVNode(_unref(FormItem), { class: "w-full" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormLabel), null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('column.group')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(FormControl), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Input), _mergeProps({
                                type: "number",
                                placeholder: _ctx.$t('column.group')
                              }, componentField, { "auto-correct": "off" }), null, 16, ["placeholder"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_unref(FormMessage))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormField), { name: "letter" }, {
                    default: _withCtx(({ componentField }) => [
                      _createVNode(_unref(FormItem), { class: "w-full" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(FormLabel), null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('column.letter')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(FormControl), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Input), _mergeProps({
                                type: "text",
                                placeholder: _ctx.$t('column.letter')
                              }, componentField, { "auto-correct": "off" }), null, 16, ["placeholder"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_unref(FormMessage))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_unref(Separator), { class: "my-1" }),
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('column.occurrence_percentage')), 1),
                _createVNode(_unref(FormField), { name: "value1" }, {
                  default: _withCtx(({ componentField }) => [
                    _createVNode(_unref(FormItem), { class: "w-full" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(FormLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("1")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(FormControl), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Input), _mergeProps({
                              type: "text",
                              placeholder: _ctx.$t('column.value')
                            }, componentField, { "auto-correct": "off" }), null, 16, ["placeholder"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_unref(FormMessage))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(FormField), { name: "value2" }, {
                  default: _withCtx(({ componentField }) => [
                    _createVNode(_unref(FormItem), { class: "w-full" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(FormLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("2")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(FormControl), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Input), _mergeProps({
                              type: "text",
                              placeholder: _ctx.$t('column.value')
                            }, componentField, { "auto-correct": "off" }), null, 16, ["placeholder"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_unref(FormMessage))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(FormField), { name: "value3" }, {
                  default: _withCtx(({ componentField }) => [
                    _createVNode(_unref(FormItem), { class: "w-full" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(FormLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("3")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(FormControl), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Input), _mergeProps({
                              type: "text",
                              placeholder: _ctx.$t('column.value')
                            }, componentField, { "auto-correct": "off" }), null, 16, ["placeholder"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_unref(FormMessage))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(FormField), { name: "value4" }, {
                  default: _withCtx(({ componentField }) => [
                    _createVNode(_unref(FormItem), { class: "w-full" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(FormLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode("4")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(FormControl), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Input), _mergeProps({
                              type: "text",
                              placeholder: _ctx.$t('column.value')
                            }, componentField, { "auto-correct": "off" }), null, 16, ["placeholder"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_unref(FormMessage))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Separator), { class: "my-4" }),
                _createVNode(_unref(DialogFooter), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DialogClose), { "as-child": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Button), {
                          type: "button",
                          variant: "secondary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('table.cancel')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Button), { type: "submit" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('table.confirm')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ], 32)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open", "onUpdate:open"]))
}
}

})